import React, { useState, useEffect } from "react";

import useFetchObjectByPost from "../../../components/Hooks/useFetchObjectByPost";
import { sto } from "../../../Context/InshData";
import { uri } from "../../../help/Api";
import LoadingPage from "../../../services/LoadingPage";
import EmployeeAdvances from "./EmployeeAdvances";
const defaultAutos = {
  Branches: [],
};

export default function EmployeeAdvancesCon(props ) {
    const [branch, setBranch] = useState({ id: -1, name: "الكل" });

    const tb = {
    wait: true,
    other: true,
    Branch: true,
    EmployeesAll: true,
    StocksInv: true,
    salesmen: true,
    BankInv:true,
    centers:true,
    stor: { ...sto, branchi: branch.id == -1 ? sto.branchi : branch.id },

    parms: {
      iempid: sto.empi,
      branch: branch.id == -1 ? sto.branchi : branch.id ,
      tname: "advance",
    },
    autos: {  },
  };


  const { object: AutoOptions, fetching: fetchAll } = useFetchObjectByPost(
    uri + "GetD",
    tb,
  );

  if (
    fetchAll ||
    !AutoOptions?.Branches
  )
    return <LoadingPage />;

  return (

    <EmployeeAdvances
      {...{
        AutoOptions: AutoOptions?.Branches ? AutoOptions : defaultAutos,
        branch,
        setBranch
      }}
    />
  );
}
